import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import "./home.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import Carousel from "react-bootstrap/Carousel";
import { axiosInstance } from "../../axiosInstance";

export const ViewMoreCatalogue = () => {
  const location = useLocation();
  const { id } = location.state || {};
  console.log("Id", id);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [productDetails, setProductDetails] = useState({});
  const [afterDiscountPrice, setAfterDiscountPrice] = useState();
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [similarProducts, setSimilarProducts] = useState([]);
  const allImages = [
    ...(productDetails?.images || []).map((img) => img.image || img),
    ...(productDetails?.product_image ? [productDetails?.product_image] : []),
  ];
  async function FetchProductDetails(id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/agent/catalogue-product-detail/${id}/`,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setProductDetails(response.data.data.product);
        const actualPrice =
          Number(response.data.data.product.default_cost_price) || 0;
        const percentage = Number(response.data.data.product.percentage) || 0;

        const discountPrice = Number(
          ((actualPrice * percentage) / 100).toFixed(2),
        );

        const afterDiscountPrice = Number(
          (actualPrice - discountPrice).toFixed(2),
        );
        setAfterDiscountPrice(afterDiscountPrice);

        setRelatedProducts(response.data.data?.related_products);
        setSimilarProducts(response.data.data?.similar_products);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        console.log(
          response.data.message || "Product details fetched successfully",
        );
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to fetch product details",
      );
      console.log("Failed to fetch product details");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchProductDetails(id);
  }, [id]);
  // carousel
  const [carouselIndex, setCarouselIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setCarouselIndex(selectedIndex);
  };

  // add to cart
  const handleAddProduct = (product_id, newQty = 1) => {
    handleAddToCart(product_id, newQty);
  };
  const handleIncrement = (product_id, currentQty) => {
    handleAddToCart(product_id, currentQty + 1);
  };
  const handleDecrement = (product_id, currentQty) => {
    handleAddToCart(product_id, currentQty - 1);
  };

  async function handleAddToCart(productId, newQty) {
    try {
      setLoading(true);
      const payload = {
        products: [
          {
            product_id: productId,
            qty: newQty,
          },
        ],
      };
      const response = await axiosInstance.post("/agent/cart/", payload);
      if (response.data.status === "Success" || response.status === 200) {
        FetchProductDetails(id);
        // toast.success(response.data.message || "Product added to cart");
        console.log("Product added to cart");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to add in cart");
      console.log("Failed to add in cart");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="inventoryContainer homeBg">
        <div className="container">
          <Link
            to="/home"
            style={{
              color: "var(--color-font-primary)",
              textDecoration: "none",
            }}
          >
            <FaArrowLeftLong /> Back
          </Link>

          <div className="productModalGrid">
            <div className="productModalLeft">
              <div>
                <div className="color-wrapper">
                  {relatedProducts.length > 0 && (
                    <div className="d-block">
                      <div className="productModalSelect">Select</div>

                      <div className="relatedProducts">
                        {relatedProducts.map((rel, index) => (
                          <img
                            key={index}
                            src={rel.product_image}
                            alt={`related-product-${index}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => FetchProductDetails(rel.id)}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <div className="productModalImage">
                  <Carousel
                    activeIndex={carouselIndex}
                    onSelect={handleSelect}
                    interval={null}
                    controls={allImages.length > 1}
                    indicators={allImages.length > 1}
                  >
                    {allImages.length > 0 ? (
                      allImages.map((img, index) => (
                        <Carousel.Item key={index}>
                          <img
                            src={img}
                            alt={`product-${index}`}
                            // className="d-block w-100"
                            className="d-block"
                            style={{ width: "100%", objectFit: "contain" }}
                          />
                        </Carousel.Item>
                      ))
                    ) : (
                      <Carousel.Item>
                        <div>Images Not Available</div>
                      </Carousel.Item>
                    )}
                  </Carousel>
                </div>
              </div>
            </div>
            <div className="productModalRight">
              <div>
                <div className="productModalTitle">
                  {productDetails.product_name}
                </div>
                <div className="productModalSubTitle">
                  {productDetails.category}
                </div>
                {/* <div className="d-flex gap-2 align-items-center">
                  <div className="productModalPrice">
                    {productDetails.default_cost_price}/-
                  </div>
                      
                  <div>per {productDetails.uom}</div>
                </div> */}
                <div className="priceWrapper">
                  {productDetails.percentage > 0 ? (
                    <>
                      <div className="ViewpriceRow">
                        <strike>
                          {Number(
                            productDetails.default_cost_price,
                          ).toLocaleString("en-IN", {
                            style: "currency",
                            currency: "INR",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          })}
                        </strike>

                        <span>₹{afterDiscountPrice}</span>
                      </div>

                      <div className="viewofferText">
                        {productDetails.percentage}% OFF
                      </div>
                    </>
                  ) : (
                    <div className="priceRow">
                      <span>
                        {Number(
                          productDetails.default_cost_price,
                        ).toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}
                      </span>
                    </div>
                  )}
                </div>
                <div className="productModalMenuContainer">
                  <div className="productModalMenu">
                    <div>Color :</div>
                    <div>{productDetails.color ?? "---"}</div>
                  </div>
                  <div className="productModalMenu">
                    <div>Variant :</div>
                    <div>{productDetails.variant ?? "---"}</div>
                  </div>
                  <div className="productModalMenu">
                    <div>Package Size :</div>
                    <div>{productDetails.package_size ?? "---"}</div>
                  </div>
                  <div className="productModalMenu">
                    <div>Points :</div>
                    <div>{productDetails.points ?? "---"}</div>
                  </div>
                </div>
                {/* <div className="productModalDesc">
                  {productDetails.description || "No data"}
                </div> */}
                <div className="productModalFeature">Description </div>
                <div className="productModalDesc">
                  {productDetails.description || "No data"}
                </div>
                <div className="productModalFeature">Features </div>
                {/* <ul className="productModalList">
                    {product.features.map((list) => (
                      <li>{list}</li>
                    ))}
                  </ul> */}
                <div className="productModalDesc">
                  {productDetails.features || "No data"}
                </div>
                <div className="btnCatalogueContainer mt-4">
                  {productDetails.product_cart_qty > 0 ? (
                    <div className="qtyHomeContainer">
                      <button
                        className="qtyHomeBtn"
                        onClick={() =>
                          handleDecrement(
                            productDetails.id,
                            productDetails.product_cart_qty,
                          )
                        }
                      >
                        -
                      </button>
                      {/* <input
                            type="number"
                            className="qtyHomeInput"
                            value={product.product_cart_qty}
                          /> */}
                      <span className="qtyHomeCount">
                        {productDetails.product_cart_qty}
                      </span>
                      <button
                        className="qtyHomeBtn"
                        onClick={() =>
                          handleIncrement(
                            productDetails.id,
                            productDetails.product_cart_qty,
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <button
                      className="btnCatalogueViewMore"
                      onClick={() => {
                        // setProductId(product.id);
                        // setQty("1");
                        handleAddProduct(productDetails.id);
                        // handlePlaceOrderShow();
                      }}
                    >
                      Add to cart
                    </button>
                  )}

                  {/* <button
                      className="btnCatalogueViewMore"
                      onClick={() =>
                        navigate("/view-more-catalogue", {
                          state: { id: product.id },
                        })
                      }
                    >
                      View More <span><FaArrowRightLong /></span>
                    </button> */}
                </div>
              </div>
            </div>
          </div>

          {/* similar products category wise  */}
          {/* cards section  */}
          <div className="productModalTitle" style={{ marginTop: "30px" }}>
            Similar Category Products
          </div>
          <div className="similarCategoryContainer ">
            {similarProducts?.length > 0 ? (
              similarProducts?.map((product) => (
                <div className="similarCard" key={product.id}>
                  <div className="similarImg">
                    <img
                      src={product.product_image}
                      alt={product.product_name}
                    />
                  </div>

                  <div>
                    <div className="productName">
                      {product.product_name ?? "---"}
                    </div>

                    <div className="productCategory">
                      {product.category ?? "---"}
                    </div>

                    <div className="priceRow">
                      <span>
                        {Number(product.default_cost_price).toLocaleString(
                          "en-IN",
                          {
                            style: "currency",
                            currency: "INR",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          },
                        )}
                      </span>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btnCatalogueViewMore"
                      onClick={() => FetchProductDetails(product.id)}
                    >
                      View More
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="noData">Data Not Available</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
